import { FilterHandler } from '@btime/react-contexts'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { Title } from '../../../components/presentation/Text'
import BucketsLoader from './_load/BucketsLoader'
import BucketsTable from './table/BucketsTable'
import ControlledModal from '../../../components/modals/ControlledModal'
import Separator from '../../../components/helpers/Separator'

const BucketsModal = props => {
  const { t } = useTranslation('listBuckets')

  return (
    <ControlledModal width="42rem" {...props}>
      <Title size="h4">{t('title')}</Title>

      <Separator weight={6} />

      <FilterHandler>
        <BucketsLoader>
          <BucketsTable />
        </BucketsLoader>
      </FilterHandler>
    </ControlledModal>
  )
}

export default BucketsModal
